import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    period,
    exploitationDate,
    firstTime,
    additional,

    taxpayerName,
    dateOfBirth,
    taxId,
    identifier,
    dateRange,
    issuedBy,
    city,
    district,
    ward,
    village,
    road,
    apartment,
    notificationAddress,
    phoneNumber,

    taxAgentName,
    taxAgentId,
    taxAgentContract,
    daytaxAgentContract,

    plotAddress,
    plotAddressCity,
    plotAddressDistrict,
    plotAddressWard,
    plotAddressVillage,
    plotAddressRoad,
    address,
    purposeOfUsingLand,
    acreage,
    startingTime,

    nonAgriculturalProductionBusiness,
    buildInfrastructure,
    buildIndustrial,
    agriculturalProduction,
    anotherPurpose,
    landUsePeriod,

    fullName,
    certificate,
    signer,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [period.name]: Yup.string().required(period.errorMsg),
  [exploitationDate.name]: Yup.number().required(exploitationDate.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [additional.name]: Yup.string().notRequired(additional.errorMsg),
  //
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [dateOfBirth.name]: Yup.number().required(dateOfBirth.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [identifier.name]: Yup.string().required(identifier.errorMsg),
  [dateRange.name]: Yup.number().required(dateRange.errorMsg),
  [issuedBy.name]: Yup.string().required(issuedBy.errorMsg),
  //
  [city.name]: Yup.string().required(city.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [ward.name]: Yup.string().required(ward.errorMsg),
  [village.name]: Yup.string().required(village.errorMsg),
  [road.name]: Yup.string().required(road.errorMsg),
  [apartment.name]: Yup.string().required(apartment.errorMsg),
  [notificationAddress.name]: Yup.string().required(notificationAddress.errorMsg),
  [phoneNumber.name]: Yup.string().required(phoneNumber.errorMsg),
  //
  [taxAgentName.name]: Yup.string().notRequired(taxAgentName.errorMsg),
  [taxAgentId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgentId.invalidMsg)
    .notRequired(taxAgentId.errorMsg),
  [taxAgentContract.name]: Yup.string().required(taxAgentContract.errorMsg),
  [daytaxAgentContract.name]: Yup.string().required(daytaxAgentContract.errorMsg),
  //
  [plotAddress.name]: Yup.string().required(plotAddress.errorMsg),
  [plotAddressCity.name]: Yup.string().required(plotAddressCity.errorMsg),
  [plotAddressDistrict.name]: Yup.string().required(plotAddressDistrict.errorMsg),
  [plotAddressWard.name]: Yup.string().required(plotAddressWard.errorMsg),
  [plotAddressVillage.name]: Yup.string().required(plotAddressVillage.errorMsg),
  [plotAddressRoad.name]: Yup.string().required(plotAddressRoad.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [acreage.name]: Yup.string().required(acreage.errorMsg),
  [purposeOfUsingLand.name]: Yup.string().required(purposeOfUsingLand.errorMsg),
  [startingTime.name]: Yup.number().required(startingTime.errorMsg),
  //
  [nonAgriculturalProductionBusiness.name]: Yup.number().required(
    nonAgriculturalProductionBusiness.errorMsg
  ),
  [buildInfrastructure.name]: Yup.number().required(buildInfrastructure.errorMsg),
  [buildIndustrial.name]: Yup.number().required(buildIndustrial.errorMsg),
  [agriculturalProduction.name]: Yup.number().required(agriculturalProduction.errorMsg),
  [anotherPurpose.name]: Yup.number().required(anotherPurpose.errorMsg),
  [landUsePeriod.name]: Yup.number().required(landUsePeriod.errorMsg),
  //
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
});

export default validation;
